// Copyright (c) 2020 Deere & Company

import actions from '../actions-list';

export const setUnit = unit => ( {
    type: actions.SET_UNIT,
    unit
} );

export const resetUnit = () => ( {
    type: actions.RESET_UNIT
} );
